import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import { FallbackProps } from 'react-error-boundary'
import { getErrorDisplayInfo } from 'services/errorService'
import { Button, Grid2 } from '@mui/material'
import { IdpRequestError, UnauthorizedRequestError } from 'models/errors'
import { Error, Info } from '@mui/icons-material'
import HeaderAdapter from '../layouts/header/HeaderAdapter'

const ErrorPage = (props: FallbackProps) => {
  const errorInfo = getErrorDisplayInfo(props.error)
  const isValidApRedirect =
    props.error instanceof UnauthorizedRequestError && props.error.isRedirectToValidAP

  return (
    <>
      <HeaderAdapter />
      {!(props.error instanceof IdpRequestError) && (
        <Grid2 container paddingY={4} paddingX={2}>
          <Alert
            severity={isValidApRedirect ? 'info' : 'error'}
            variant="outlined"
            icon={isValidApRedirect ? <Info /> : <Error />}
            action={
              errorInfo.hasTorna && <Button onClick={props.resetErrorBoundary}>Tornar</Button>
            }>
            <AlertTitle>
              <strong>{errorInfo.title}</strong>
            </AlertTitle>
            {errorInfo.message}
            <a href={errorInfo.linkUrl} target="_blank" rel="noopener noreferrer">
              {errorInfo.linkMessage}
            </a>
          </Alert>
        </Grid2>
      )}
    </>
  )
}

export default ErrorPage
